import { LayoutResponse, type LayoutPayload } from "@empire/shared";
import { request } from "./client.js";

/**
 * Save and load a defence (S5-2 from the client's side).
 *
 * Both directions speak the sparse wire format from `@empire/shared`, and both
 * parse the reply with `LayoutResponse` — so if the server ever starts sending
 * something the client does not expect, it fails here, loudly, rather than
 * three screens later with a board that is subtly wrong.
 */

export function fetchLayout(villageId: string, token: string): Promise<LayoutResponse> {
  return request(`/api/v1/villages/${villageId}/layout`, LayoutResponse, { token });
}

export function putLayout(
  villageId: string,
  token: string,
  payload: LayoutPayload
): Promise<LayoutResponse> {
  return request(`/api/v1/villages/${villageId}/layout`, LayoutResponse, {
    method: "PUT",
    token,
    body: payload,
  });
}
